import { Component, Inject, OnInit, ElementRef, ViewChild } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { LoaderService } from '../../shared/loader/loader.service';
import { StatusConstant } from '../status/status-constant';

@Component({
  selector: 'app-automationdetails',
  templateUrl: './automationdetails.component.html',
  styleUrls: ['./automationdetails.component.scss']
})

export class AutomationDetailsComponent implements OnInit {
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any = [] = [];
  spinner: boolean = false;
  OfficeIDList: any = [] = [];
  myOfficeID: any; 
  ProcessedDetailList: any = [] = [];

  fieldTemplateName:string="";
  isFieldProcessed:boolean=false;

  promptTemplateName:string="";
  isPromptProcessed:boolean=false;

  referralTemplateName:string="";
  isReferralProcessed:boolean=false;

  aiAutomationTemplateName:string="";
  status:number=0;
  attempts:number=0;

  isContentProcessed:boolean=false;
  aiAutomationProcessStatus:number=0;
  

  constructor(private dialog: MatDialog, public dialogRef: MatDialogRef<AutomationDetailsComponent>,
    private encryptionAlgo: EncryptionService, private settingsService: SettingService,
    private reusableClass: ReusableClasses, private toastr: ToastrService,
    private loaderService: LoaderService,private statusConst: StatusConstant,
    @Inject(MAT_DIALOG_DATA) public data: any,) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId') ?? '';
    this.organizationId = sessionStorage.getItem('organizationID') ?? '';
    if (encryptedtoken != null) {
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
      this.currentUser = jwt_decode(token);
      var offices = JSON.parse(sessionStorage.getItem('officeList') ?? '[]');
      offices.forEach((oe: any) => {
        this.OfficeIDList.push(oe.officeID);
        if (oe.isMyoffice == true)
          this.myOfficeID = oe.officeID;
      });
    }
  }


  ngOnInit(): void {
    this.getdetails();
  }

  getdetails() {
    var ReqModel = {
      aiAutomationID: this.data.aiAutomationID,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId)
    };
    this.loaderService.show();
    this.settingsService.getAIAutomationProcessedDetail(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
         this.fieldTemplateName= response.data.fieldTemplateName;
         this.isFieldProcessed= response.data.isFieldProcessed;

         this.promptTemplateName= response.data.promptTemplateName;
         this.isPromptProcessed= response.data.isPromptProcessed;

         this.referralTemplateName= response.data.referralTemplateName;
         this.isReferralProcessed= response.data.isReferralProcessed;

         this.aiAutomationTemplateName = response.data.aiAutomationTemplateName;
         this.status= response.data.status;
         this.attempts= response.data.attempts;   

         this.isContentProcessed= response.data.isContentProcessed;
         this.aiAutomationProcessStatus = response.data.status;
        }
        else {
          this.loaderService.hide();
          this.ProcessedDetailList = [];          
        }
      }
      else {
        this.loaderService.hide();
        this.ProcessedDetailList = [];       
      }
    });
  }


  close() {
    this.dialogRef.close();
  }


}
